import React from "react";
import { History, ArrowUpRight } from "lucide-react";
import { THEME_META } from "../../lib/catalog";

export default function ContinueStrip({ articles, opened }) {
  const recent = opened
    .map((o) => articles.find((a) => a.slug === o.slug))
    .filter(Boolean)
    .slice(0, 3);
  if (!recent.length) return null;

  return (
    <div data-testid="continue-strip" className="mb-6 border border-[var(--line)] bg-[var(--surface)] p-4 sm:p-5">
      <p className="meta-label text-[0.58rem] text-[var(--gold)] flex items-center gap-2">
        <History size={12} /> Continue where you left off
      </p>
      <div className="mt-3 grid sm:grid-cols-3 gap-3">
        {recent.map((a) => (
          <a key={a.slug} data-testid={`continue-${a.slug}`} href={a.url} target="_blank" rel="noopener noreferrer"
            className="group flex items-start gap-3 p-3 border border-[var(--line)] hover:border-[var(--gold)] transition-colors">
            <span className="mt-1.5 w-2 h-2 rounded-full shrink-0" style={{ backgroundColor: THEME_META[a.theme]?.color }} />
            <span className="flex-1 font-serif text-[0.98rem] leading-snug text-[var(--txt)] line-clamp-2">{a.title}</span>
            <ArrowUpRight size={14} className="shrink-0 text-[var(--muted)] group-hover:text-[var(--gold)] transition-colors" />
          </a>
        ))}
      </div>
    </div>
  );
}
